module.exports = __webpack_public_path__ + "media/images/countdown__background-61fcc3e3bd5146a09158dc3dbd99949c.jpg";